import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAgencyById } from "../utils/api";

export const fetchAgencyById = createAsyncThunk(
  'agency/fetchAgencyById',
  async ({accessToken, id}, thunkAPI) => {
    const response = await getAgencyById(accessToken, id);

    if (!response.data.success) {
      throw new Error('Failed to fetch agency');
    }

    return response.data;
  }
);

const editAgencySlice = createSlice({
  name: 'agency',
  initialState: {
    agencyData: {},
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAgencyById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAgencyById.fulfilled, (state, action) => {
        state.loading = false;
        state.agencyData = action.payload.data[0];
      })
      .addCase(fetchAgencyById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export default editAgencySlice.reducer;
